import { LoginService } from "../services";

function Home() {
  const user = LoginService.getUser();
  return (
    <div>
      <h1>Welcome {user.LongName}!</h1>
      <h2> You are at home page.</h2>
    </div>
  );
}

export default Home;
